<script setup lang="ts">
  const { t } = useI18n()
  const localePath = useLocalePath()

  const showTop = ref(false)

  function onScroll() {
    showTop.value = window.scrollY > 400
  }

  function scrollTop() {
    window.scrollTo({ top: 0, behavior: 'smooth' })
  }

  onMounted(() => {
    onScroll()
    window.addEventListener('scroll', onScroll, { passive: true })
    onUnmounted(() => window.removeEventListener('scroll', onScroll))
  })
</script>

<template>
  <footer class="footer">
    <div class="container">
      <div class="footer-grid">
        <div class="footer-about">
          <NuxtLink :to="localePath('/')" class="footer-logo">
            <img src="/images/home_logo_solid.png" :alt="t('brand.name')" />
          </NuxtLink>
          <p>{{ t('footer.about') }}</p>
          <div class="footer-contact">
            <h4 class="footer-contact-title">{{ t('footer.contactUs') }}</h4>
            <div class="footer-contact-item">
              <span class="footer-contact-label">{{ t('footer.address') }}</span>
              <span class="footer-contact-value">{{ t('footer.addressValue') }}</span>
            </div>
            <div class="footer-contact-item">
              <span class="footer-contact-label">{{ t('footer.phone') }}</span>
              <span class="footer-contact-value">{{ t('footer.phoneValue') }}</span>
            </div>
            <div class="footer-contact-item">
              <span class="footer-contact-label">{{ t('footer.email') }}</span>
              <span class="footer-contact-value">{{ t('footer.emailValue') }}</span>
            </div>
            <div class="footer-contact-item">
              <span class="footer-contact-label">{{ t('footer.zip') }}</span>
              <span class="footer-contact-value">{{ t('footer.zipValue') }}</span>
            </div>
          </div>
        </div>
        <div class="footer-col">
          <h4>{{ t('footer.quickNav') }}</h4>
          <ul>
            <li>
              <NuxtLink :to="localePath('/about')">{{ t('nav.about') }}</NuxtLink>
            </li>
            <li>
              <NuxtLink :to="localePath('/programs')">{{ t('nav.programs') }}</NuxtLink>
            </li>
            <li>
              <NuxtLink :to="localePath('/education')">{{ t('nav.education') }}</NuxtLink>
            </li>
            <li>
              <NuxtLink :to="localePath('/faculty')">{{ t('nav.faculty') }}</NuxtLink>
            </li>
            <li>
              <NuxtLink :to="localePath('/research')">{{ t('nav.research') }}</NuxtLink>
            </li>
          </ul>
        </div>
        <div class="footer-col">
          <h4>{{ t('footer.admissionJobs') }}</h4>
          <ul>
            <li>
              <NuxtLink :to="localePath('/admission')">{{ t('footer.brochure') }}</NuxtLink>
            </li>
            <li>
              <NuxtLink :to="localePath('/admission')">{{ t('footer.guide') }}</NuxtLink>
            </li>
            <li>
              <a href="#">{{ t('footer.career') }}</a>
            </li>
            <li>
              <a href="#">{{ t('footer.coop') }}</a>
            </li>
          </ul>
        </div>
        <div class="footer-col">
          <h4>{{ t('footer.links') }}</h4>
          <ul>
            <li>
              <a href="http://www.geely.com/" target="_blank" rel="noopener">{{ t('footer.geely') }}</a>
            </li>
            <li>
              <a href="#" target="_blank">{{ t('footer.talent') }}</a>
            </li>
            <li>
              <a href="https://www.xinwei-ai.com/" target="_blank" rel="noopener">{{ t('footer.xinwei') }}</a>
            </li>
            <li>
              <a href="https://www.sanyau.edu.cn/" target="_blank" rel="noopener">{{ t('footer.sanyau') }}</a>
            </li>
            <li>
              <a href="https://www.guc.edu.cn/" target="_blank" rel="noopener">{{ t('footer.guc') }}</a>
            </li>
          </ul>
        </div>
      </div>
      <div class="footer-bottom">
        <p>
          <img src="/images/110.png" class="footer-beian-icon" alt="" />
          <a href="https://beian.mps.gov.cn/#/query/webSearch?code=46020002000470" rel="noreferrer" target="_blank">
            琼公网安备46020002000470号
          </a>
          <span class="footer-bottom-sep">|</span>
          <a href="https://beian.miit.gov.cn/" target="_blank" rel="noopener">琼ICP备2021008302号-19</a>
          <span class="footer-bottom-sep">|</span>
          {{ t('footer.copyright') }}
          <span class="footer-bottom-sep">|</span>
          {{ t('footer.techSupport') }}
        </p>
      </div>
    </div>
  </footer>

  <button class="back-to-top" type="button" :class="{ visible: showTop }" @click="scrollTop">↑</button>
</template>
